import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import {
  HELPER_TEXT_TYPES,
  helpersIsEmpty,
  I18N_VALUE_COLLAPSED,
  I18N_VALUE_FLAT,
} from '@icp/form-renderer-core';
import { IconButton } from '@mui/material';
import { Icon } from '@icp/components';
import { FormHelperTextMaterial } from '../../../FormHelperText';
import TextareaSupportI18n from './TextareaSupportI18n';
import { useIsInDesign } from '../../../FormRenderCtx';

const TextareaMaterial = forwardRef(function TextareaMaterial(props, ref) {
  const {
    id,
    title,
    value,
    disabled,
    readonly,
    allowI18nValue,
    componentProps = {},
    validation,
    status,
    helpers,
    onChange,
    onTouchChanged,

    simpleMode,
    i18nInputLayout,
    onToggleI18nInputLayout,
  } = props;

  const isInDesign = useIsInDesign();

  return (
    <>
      <TextareaSupportI18n
        {...componentProps}
        simpleMode={simpleMode}
        multiline={true}
        allowI18nValue={allowI18nValue}
        i18nInputLayout={i18nInputLayout}
        id={id}
        label={title}
        value={value}
        error={status === 'error'}
        helperText={!helpersIsEmpty(helpers) ? <FormHelperTextMaterial helpers={helpers} /> : null}
        required={validation?.required}
        disabled={disabled}
        readonly={readonly}
        onChange={onChange}
        onBlur={onTouchChanged}
        ref={ref}
      />
      {!isInDesign && allowI18nValue ? (
        <IconButton
          className="i18n-input-layout-switch-button"
          size="small"
          onClick={onToggleI18nInputLayout}
        >
          {i18nInputLayout === I18N_VALUE_COLLAPSED ? (
            <Icon name="oct:chevron-right" size={16} />
          ) : (
            <Icon name="oct:chevron-down" size={16} />
          )}
        </IconButton>
      ) : null}
    </>
  );
});

TextareaMaterial.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      longText: PropTypes.string,
    }),
  ]),
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  allowI18nValue: PropTypes.bool,
  componentProps: PropTypes.shape({}),
  validation: PropTypes.shape({
    required: PropTypes.bool,
    maxLength: PropTypes.number,
  }),
  status: PropTypes.oneOf(HELPER_TEXT_TYPES),
  helpers: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(HELPER_TEXT_TYPES),
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  onTouchChanged: PropTypes.func,
  simpleMode: PropTypes.bool,
  i18nInputLayout: PropTypes.oneOf([I18N_VALUE_COLLAPSED, I18N_VALUE_FLAT]),
  onToggleI18nInputLayout: PropTypes.func,
};

export default TextareaMaterial;
